// External dependencies
import { registerRootComponent } from 'expo';
import { createRoot } from 'react-dom/client';
import { createElement } from 'react';
import { Platform } from 'react-native';

// Project components
import App from './App';

// Register the root component for mobile platforms
if (Platform.OS !== 'web') {
  registerRootComponent(App);
} else {
  // For web platforms, use React DOM's createRoot
  const rootElement =
    document.getElementById('root') || document.createElement('div');
  if (!rootElement.id) {
    rootElement.id = 'root';
    document.body.appendChild(rootElement);
  }
  const root = createRoot(rootElement);
  root.render(createElement(App));
}
